import React from 'react';
import { Info, AlertCircle } from 'lucide-react';

interface StatusNoticesProps {
  isPublic: boolean;
  profileStatus: string;
  activeTab: string;
  t: (key: string) => string;
}

const StatusNotices: React.FC<StatusNoticesProps> = ({
  isPublic,
  profileStatus,
  activeTab,
  t
}) => {
  if (activeTab !== 'configuration') return null;

  return (
    <>
      {/* Public Visibility Notice */}
      {isPublic && (
        <div className="bg-primary/5 border border-primary/20 rounded-xl p-4 mb-6 flex items-start gap-3">
          <Info className="w-5 h-5 text-primary mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-foreground">{t('Public Profile Active')}</p>
            <p className="text-sm text-muted-foreground mt-1">
              {t('Your profile is publicly accessible outside the company. Anyone with the link can view the information you\'ve chosen to share.')}
            </p>
          </div>
        </div>
      )}

      {/* Pending Approval Notice */}
      {profileStatus === 'pendingapproval' && (
        <div className="bg-warning/10 border border-warning/20 rounded-xl p-4 mb-6 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-warning mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-foreground">{t('Pending HR Approval')}</p>
            <p className="text-sm text-muted-foreground mt-1">
              {t('Your profile is awaiting HR approval. Once approved, it will be publicly accessible.')}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusNotices;
